/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Like } from '../models/Like';
import type { SmallArtist } from '../models/SmallArtist';
import type { View } from '../models/View';
import { request as __request } from '../core/request';

export class UserActionsService {

    /**
     * Like Artist
     * @param artistId
     * @param unlike
     * @result Like Successful Response
     * @throws ApiError
     */
    public static async likeArtist({
        artistId,
        unlike = false,
    }: {
        artistId: string,
        unlike?: boolean,
    }
): Promise<Like> {
    const result = await __request({
        method: 'PATCH',
        path: `/user_actions/like_artist`,
        query: {
            'artist_id': artistId,
            'unlike': unlike,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get Liked Artists
 * @param limit
 * @param lastDocId
 * @result SmallArtist Successful Response
 * @throws ApiError
 */
public static async getLikedArtists({
    limit = 20,
    lastDocId,
}: {
    limit?: number,
    lastDocId?: string,
}
): Promise<Array<SmallArtist>> {
    const result = await __request({
        method: 'GET',
        path: `/user_actions/get_liked_artists`,
        query: {
            'limit': limit,
            'last_doc_id': lastDocId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get Liked Artists Ids
 * @param limit
 * @result string Successful Response
 * @throws ApiError
 */
public static async getLikedArtistsIds({
    limit,
}: {
    limit?: number,
}
): Promise<Array<string>> {
    const result = await __request({
        method: 'GET',
        path: `/user_actions/get_liked_artists_ids`,
        query: {
            'limit': limit,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * View Artist
 * @param artistId
 * @result View Successful Response
 * @throws ApiError
 */
public static async viewArtist({
    artistId,
}: {
    artistId: string,
}
): Promise<View> {
    const result = await __request({
        method: 'PATCH',
        path: `/user_actions/view_artist`,
        query: {
            'artist_id': artistId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get Viewed Artists
 * @param limit
 * @param lastDocId
 * @result SmallArtist Successful Response
 * @throws ApiError
 */
public static async getViewedArtists({
    limit = 20,
    lastDocId,
}: {
    limit?: number,
    lastDocId?: string,
}
): Promise<Array<SmallArtist>> {
    const result = await __request({
        method: 'GET',
        path: `/user_actions/get_viewed_artists`,
        query: {
            'limit': limit,
            'last_doc_id': lastDocId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

}